import {colors,refs} from 'abri-tole-consts';
export const CSS_LOWSCREEN_BREAKPOINT = '(max-height:760px)';
export const CSS_MOBILE_BREAKPOINT = '(max-width: 999.98px)';
export const CSS_MINIMOBILE_BREAKPOINT = '(max-width: 374.98px)';
export const CSS_SMALLDESKTOP_BREAKPOINT = '(min-width: 999.99px) and (max-width: 1099.98px)';
export const CSS_PADDING = '15px';
export const CSS_PADDING_COMPACT = '10px';
export const CSS_COLOR_TEXT_PRIMARY = '#333333';
export const CSS_COLOR_TEXT_SECONDARY = '#555555';
export const CSS_COLOR_RED = '#e00017';
export const CSS_COLOR_BORDERS = '#d9d9d9';
export const CSS_COLOR_ACTION = '#0192df';
export const CSS_COLOR_SELECTED = CSS_COLOR_ACTION;
export const CSS_COLOR_DISPLAYED = '#4b94ba';
export const CSS_COLOR_EDITOR_BACKGROUND = '#f8f8f8';
export const CSS_SELECTOR_RADIUS = '6px';
export const CSS_INPUT_RADIUS = CSS_SELECTOR_RADIUS;

export const BETA_MODE = (process.env.NODE_ENV === 'development');
export const IMG_PREFIX = 'https://assets.abri-tole.fr/img/?';

export const CECA_COLORS = colors;
export const CECA_REFS = refs;

export const CECA_OPTIONS_POSSIBILITIES_HEIGHT_THRESHOLD = 3;
export const CECA_OPTIONS_POSSIBILITIES_WIDTHS = {
	// largeurs possibles en m, ex: [3,4,5,6]
	// b3 > 	below threshold 	> 	petite hauteur
	// o3 > 	over threshold 		> 	grande hauteur
	'p3b':[3,4,5,6],//,6.5 retirés le 31/03/2023 suite à demande Fifi
	'p3o':[3,4,5,6],//,6.5 retirés le 31/03/2023 suite à demande Fifi
	'p4b':[3,4,5,6],
	'p4o':[3,4,5,6],
	'p5b':[3,4,5,6],
	'p5o':[3,4,5,6]
};
